import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArticleList, ArticleType, rng } from '../../../amorg-common';
import { articlesClientApi } from '../../../api/articlesClientApi';
import { Button } from '../../../designSystem/button/Button';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { SelectField } from '../../../designSystem/formField/SelectField';
import { TextField } from '../../../designSystem/formField/text/TextField';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { Modal } from '../../../designSystem/Modal';
import { H1 } from '../../../designSystem/typography/Heading';
import { AdminTab } from '../_components/AdminTab';
import { AmorgAdminPageProvider } from '../AmorgAdminPageContext';
import { ArticlesTab } from './_components/ArticlesTab';
import { FilteredArticleTable } from './_components/FilteredArticleTable';

export default function ArticlesList (): JSX.Element 
{
    React.useEffect(() =>
    {
        document.title = 'Amorgy - Lovkrav';
    }, []);
    
    const navigate = useNavigate();

    async function handleArticleCreated (articleId: string)
    {
        navigate(`/amorgy/articles/${articleId}`);
    }

    return (
        <AmorgAdminPageProvider>
            <LoadingPageOverlay loading={false} />
            <SingleColumnLayout
                wide
                noDivider
                headerContainer={
                    <Flex flexDirection='column' gap={16}>
                        <AdminTab selectedTab='articles' />
                        <ArticlesTab selectedTab='articles' />
                    </Flex>
                }

                contentContainer={

                    <Flex flexDirection='column' gap={16}>
                        <H1>Lovkrav</H1>

                        <FilteredArticleTable subscriberId='' onRowClick={(aid) => navigate(`/amorgy/articles/${aid}`)}
                            latestNote
                            subscriptionCount
                            warnings
                            buttons={[
                                <CreateArticleModalButton key="createButton" onArticleCreated={handleArticleCreated} />
                            ]} />

                    </Flex>
                } />

        </AmorgAdminPageProvider>
    );
}


type CreateArticleModalButtonProps = {
    onArticleCreated: (articleId: string) => void;
};
function CreateArticleModalButton (props: CreateArticleModalButtonProps): JSX.Element
{
    const [show, setShow] = React.useState(false);

    const [lists, setLists] = React.useState<ArticleList[]>([]);
    const [topicId, setTopicId] = React.useState('');

    const [types, setTypes] = React.useState<ArticleType[]>([]);
    const [typeId, setTypeId] = React.useState('');

    const [title, setTitle] = React.useState('');

    const [error, setError] = React.useState(false);

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            setLists(await articlesClientApi.getLists());
            setTypes(await articlesClientApi.getTypes());
        };
        getData();
    }, []);

    function handleClickOpenModal ()
    {
        setError(false);
        setShow(true);
        setTopicId('');
        setTypeId('');
        setTitle('');
    }

    async function handleCreateArticle ()
    {
        const newId = rng.getRandomId();
        const result = await articlesClientApi.createArticle(newId, rng.getRandomId(), typeId, topicId, title);
        if (result.status === 'success')
        {
            props.onArticleCreated(newId);
            setShow(false);
        }
        else
        {
            console.log('error', result.clientMessage);
            setError(true);
        }
    }

    return (
        <div>
            <Button icon="actions_plus" variant="filled" text='Opret lovkrav' onClick={handleClickOpenModal} emphasize />

            <Modal title={'Opret nyt lovkrav'} showModal={show}
                onCancel={() => setShow(false)}
                content={
                    <>

                        {error && <div style={{ color: 'red' }}>Der opstod en fejl</div>}

                        <SelectField label='Liste/emne'
                            selectedValue={topicId}
                            emptyText='Vælg emne'
                            onChange={(value) => setTopicId(value)}
                            options={lists.map(l =>
                                ({ text: l.name, options: l.topics.map(t => ({ text: t.name, value: t.id })) }))}
                        />

                        <SelectField label='Type lovkrav'
                            selectedValue={typeId}
                            emptyText='Vælg type'
                            onChange={(value) => setTypeId(value)}
                            options={types.map(t => ({ text: t.name, value: t.id }))}
                        />

                        <TextField value={title} label={'Titel'} onChange={(value) => setTitle(value)} />

                        <Button variant='filled' text='Opret' disabled={!topicId || !typeId || !title} onClick={handleCreateArticle} />
                    </>
                }
            />
        </div>
    );
}